"use client";

import { Input } from "@/shadcn/components/ui/input";
import Link from "next/link";
import { useState } from "react";
import { IoClose } from "react-icons/io5";
import { cleanSubstring } from "@std/lib/helpers";
import { useSelectedLayoutSegment } from "next/navigation";
import { cn } from "@std/@/shadcn/lib/utils";

export const SocialLink = ({ children, href, label }) => (
  <Link
    aria-label={label}
    href={href}
    target="_blank"
    rel="noreferrer noopener"
    className="w-8 hover:text-gray-300 transition ease-in-out duration-200"
  >
    {children}
  </Link>
);

const navClasses = {
  iconPageActive: "text-cyan-300 transition ease-in-out duration-200",
  iconPageInactive:
    "text-gray-300 hover:text-gray-400 transition ease-in-out duration-200",
  textPageActive:
    "text-white hover:text-gray-300 transition ease-in-out duration-200",
  textPageInactive:
    "text-gray-300 hover:text-gray-400 transition ease-in-out duration-200",
};

export const NavLink = ({
  className: inputClassName,
  href,
  children,
  strict,
  icon: Icon,
}) => {
  const path = useSelectedLayoutSegment();

  const pathMeetsCondition = href.replace("/", "");

  const condition = strict
    ? path.startsWith(pathMeetsCondition)
    : path === pathMeetsCondition;

  return (
    <Link
      href={href}
      className={cn(
        condition ? navClasses.textPageActive : navClasses.textPageInactive,
        `flex flex-row items-center gap-x-2 text-2xl md:text-lg`,
        inputClassName
      )}
    >
      <Icon
        className={
          (condition
            ? navClasses.iconPageActive
            : navClasses.iconPageInactive) + `w-5 min-w-[30px] h-5`
        }
      />
      {children}
    </Link>
  );
};

export const HomeLink = () => {
  const path = useSelectedLayoutSegment();

  return (
    <Link href={"/"} className={navClasses.iconPageActive}>
      Home
    </Link>
  );
};

export const Search = () => {
  const [content, setContent] = useState("");
  return (
    <div className="w-full sm:w-[70%] md:w-[60%] lg:ml-2 px-4">
      <form action="/v/s" method="GET">
        <label
          htmlFor="q"
          className="mb-2 text-sm font-medium sr-only text-gray-300"
        >
          Search
        </label>
        <div className="block relative">
          <div className="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none">
            <svg
              aria-hidden="true"
              className="w-5 h-5 text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              ></path>
            </svg>
          </div>
          <div
            className={`hidden md:flex cursor-pointer absolute inset-y-0 right-0 items-center justify-center my-4 mr-6 rounded-r-full pointer-events-none`}
          >
            <IoClose
              className={`${
                `${content}`.trim() === "" && "hidden"
              } md:text-white md:bg-gray-800 text-slate-900 bg-slate-900 -mr-2`}
            />
          </div>
          <Input
            type="search"
            name="q"
            id="q"
            className={`no-search-x border-[0.5px] bg-slate-900 md:bg-gray-800 bg-transparent block py-2 pl-10 w-full text-sm rounded-full placeholder-gray-400 border-gray-500 text-white focus:ring-transparent focus:border-gray-400 md:focus:ring-blue-500 md:focus:border-blue-500 font-BreezeAltHeader font-medium text-center md:text-left`}
            formNoValidate
            noValidate
            title=""
            placeholder={"Search all videos"}
            onChange={(e) => {
              setContent(cleanSubstring(e.target.value, "&"));
            }}
          />
        </div>
      </form>
    </div>
  );
};
